export function initPwaBackButton() {
    const savedUrl = sessionStorage.getItem('pwaEventUrl');
    if (!savedUrl)
        return;
    try {
        if (new URL(window.location.href).pathname === new URL(savedUrl).pathname)
            return;
    }
    catch {
        return;
    }
    const wrap = document.createElement('a');
    wrap.href = savedUrl;
    wrap.className = 'pwa-back-btn';
    wrap.setAttribute('aria-label', 'Back to event');
    const icon = document.createElement('span');
    icon.className = 'icon icon--angle-left';
    wrap.appendChild(icon);
    document.body.appendChild(wrap);
}
